import React, {Fragment, useContext, useRef, useState} from "react";
import {Tab} from "@headlessui/react";
import PermissionEnum from "../../controllers/PermissionEnum";
import AppContext from "../../appContext";
import {classes} from "../Leafs";
import Dialog from "../../components/Dialog";
import {PendingSubmissionsRef} from "../submission/PendingSubmissionsLeaf";
import WaitingSoilSubmissions from "./WaitingSoilSubmissions";
import SoilController from "../../controllers/SoilController";
import CompletedResultsSoil from "./CompletedResultsSoil";
import {PendingSubmissionsSoil} from "../submission/PendingSubmissionsSoil";
import {showSuccessOrFailed} from "../../Snacks";
import SubmissionPrepareSoil from "./SubmissionPrepareSoil";

const SoilSubmissions: React.FC = () => {
    const context = useContext(AppContext)

    const pendingSubmissionsRef = useRef<PendingSubmissionsRef>(null);

    const [showPrepare, setShowPrepare] = useState(false);
    const [prepareDataIds, setPrepareDataIds] = useState<number[]>([]);

    function newShow() {
        setPrepareDataIds([]);
        setShowPrepare(true);
    }
    function show(dataIds: number[]) {
        setPrepareDataIds(dataIds);
        setShowPrepare(true);
    }

    function archiveSoil(ids: number[]) {
        showSuccessOrFailed(context, SoilController.archiveSoil({
            ids: ids
        })).then(() => {
            pendingSubmissionsRef.current?.refresh();
        })
    }

    return <div className="bg-white p-2 shadow">

        <Tab.Group defaultIndex={-1}>
            <Tab.List className="flex space-x-1 rounded-xl bg-primary-500 p-1">
                {
                    context.hasPermission(PermissionEnum.SubmissionsPrepare) ?
                        <Tab as={Fragment}>
                            {({selected}) => (
                                <button className={classes(selected)}>
                                    Prepare
                                </button>
                            )}
                        </Tab>
                        : null
                }
                {
                    context.hasPermission(PermissionEnum.SubmissionsWaitingForLab) ?
                        <Tab as={Fragment}>
                            {({selected}) => (
                                <button className={classes(selected)}>
                                    Waiting for Lab
                                </button>
                            )}
                        </Tab>
                        : null
                }
                {
                    context.hasPermission(PermissionEnum.SubmissionsResults) ?
                        <Tab as={Fragment}>
                            {({selected}) => (
                                <button className={classes(selected)}>
                                    Results
                                </button>
                            )}
                        </Tab>
                        : null
                }
                {
                    context.hasPermission(PermissionEnum.SubmissionsCompleted) ?
                        <Tab as={Fragment}>
                            {({selected}) => (
                                <button className={classes(selected)}>
                                    Completed
                                </button>
                            )}
                        </Tab>
                        : null
                }
                {
                    context.hasPermission(PermissionEnum.SubmissionsDelete) ?
                        <Tab as={Fragment}>
                            {({selected}) => (
                                <button className={classes(selected)}>
                                    Archived
                                </button>
                            )}
                        </Tab>
                        : null
                }
            </Tab.List>

            <Tab.Panels>
                {
                    context.hasPermission(PermissionEnum.SubmissionsPrepare) ?
                        <Tab.Panel>
                            <PendingSubmissionsSoil
                                ref={pendingSubmissionsRef}
                                newSubmission={() => {
                                    newShow()
                                }}
                                call={SoilController.pendingSubmissions}
                                archive={archiveSoil}
                                prepare={(dataIds) => show(dataIds)}/>
                        </Tab.Panel>
                        : null
                }
                {
                    context.hasPermission(PermissionEnum.SubmissionsWaitingForLab) ?
                        <Tab.Panel>
                            <WaitingSoilSubmissions/>
                        </Tab.Panel>
                        : null
                }
                {
                    context.hasPermission(PermissionEnum.SubmissionsResults) ?
                        <Tab.Panel>
                            <CompletedResultsSoil archived={false} canPost={false} call={SoilController.pagedResults}/>
                        </Tab.Panel>
                        : null
                }
                {
                    context.hasPermission(PermissionEnum.SubmissionsCompleted) ?
                        <Tab.Panel>
                            <CompletedResultsSoil archived={false} canPost={true} call={SoilController.pagedCompleted}/>
                        </Tab.Panel>
                        : null
                }
                {
                    context.hasPermission(PermissionEnum.SubmissionsDelete) ?
                        <Tab.Panel>
                            <CompletedResultsSoil archived={true} canPost={false} call={SoilController.pagedArchived}/>
                        </Tab.Panel>
                        : null
                }
            </Tab.Panels>
        </Tab.Group>

        <Dialog
            title="Prepare Submission"
            body={
                <SubmissionPrepareSoil
                    close={() => {
                        setShowPrepare(false)
                        pendingSubmissionsRef.current?.refresh();
                    }}
                    dataIds={prepareDataIds}
                />
            }
            show={showPrepare}
            setShow={(state) => {
                setShowPrepare(state)
                pendingSubmissionsRef.current?.refresh();
            }}
        />
    </div>;
}

export default SoilSubmissions;